import { ComponentType } from '@angular/cdk/overlay';
import { inject, Injectable } from '@angular/core';
import {
  MatDialog,
  MatDialogConfig,
  MatDialogRef,
} from '@angular/material/dialog';
import { AppStateService } from '@shared/services';
import { ModalConfigInterface } from './modals.interface';

@Injectable({
  providedIn: 'root',
})
export class ModalsService {
  private readonly dialog = inject(MatDialog);
  private readonly appStateService = inject(AppStateService);

  open<T, D = unknown, R = unknown>(
    component: ComponentType<T>,
    config?: ModalConfigInterface<D>,
  ): MatDialogRef<T, R> {
    if (!this.appStateService.isMobileResolution()) {
      return this.dialog.open<T, D, R>(component, {
        enterAnimationDuration: 300,
        exitAnimationDuration: 300,
        panelClass: 'base-modal',
        backdropClass: 'base-modal-backdrop',
        autoFocus: 'shared-form-input-text input',
        width: '400px',
        disableClose: true,
        ...config,
      });
    } else {
      const mobileConfig: MatDialogConfig = {
        enterAnimationDuration: 300,
        exitAnimationDuration: 300,
        backdropClass: 'base-modal-backdrop',
        minWidth: '100%',
        maxWidth: '100vw',
        maxHeight: '100dvh',
        height: config?.height ?? 'auto',
        autoFocus: false,
        position: {
          bottom: '0',
        },
        ...config,
        panelClass: config?.panelClass ?? 'base-modal',
      };
      if (config?.viewContainerRef) {
        mobileConfig.viewContainerRef = config?.viewContainerRef;
      }
      return this.dialog.open<T, D, R>(component, mobileConfig);
    }
  }
}
